class FookizDetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summaryElement = this.mainDetailsToggle.querySelector('summary');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mouseLeaveTimeout = null;

    this.summaryElement.addEventListener('mouseenter', this.open.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle.addEventListener('mouseenter', this.cancelClose.bind(this));
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summaryElement.setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summaryElement.setAttribute('aria-expanded', false);
  }

  onMouseLeave() {
    this.mouseLeaveTimeout = setTimeout(() => this.close(), 200);
  }

  cancelClose() {
    clearTimeout(this.mouseLeaveTimeout);
  }
}

customElements.define('fookiz-details-disclosure', FookizDetailsDisclosure);

class FookizHeaderMenu extends FookizDetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('fookiz-menu', FookizHeaderMenu);
